import { useParams, Link } from "react-router-dom";
import blogData from "../data/blogData"; 
import Feat from "../assets/ResourcePics/FeaturedArticle.png";
import bg1 from "../assets/BackgroundImages/BG image 1.png";
import bg2 from "../assets/BackgroundImages/BG image 2.png";    
import bg4 from "../assets/BackgroundImages/BG image 4.png";
import bg6 from "../assets/BackgroundImages/BG image 6.png";
const BlogPost = () => {
  const { id } = useParams();
  const blog = blogData.find((b) => b.id === parseInt(id));

  if (!blog) {
    return <div className="text-white text-center p-10">Blog not found!</div>;
  }

  return (
    <div className="py-12 px-6">
         {/* Background Images */}
 <div className="hidden md:block -z-10 absolute h-full opacity-50 left-0 translate-y-[30px] ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
<div className="-z-10 absolute h-full opacity-50 left-0 translate-y-[3000px] md:translate-y-[500px] ">
  <img
    src={bg4}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
<div className="hidden md:block -z-10 absolute h-full opacity-50 left-0 translate-y-[4000px] md:translate-y-[1400px] ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className="-z-10 absolute h-full opacity-50 left-0 md:translate-y-[2200px] ">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>

<div className=" -z-10 absolute h-full opacity-50 right-0 translate-y-[500px] ">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
<div className=" -z-10 absolute h-full opacity-50 right-0 translate-y-[1000px] ">
  <img
    src={bg6}
    alt="bg"
    className="h-full w-auto object-contain"
  /> 
</div>

<div className=" -z-10 absolute h-full opacity-50 right-0 translate-y-[1800px] ">
  <img
    src={bg6}
    alt="bg"
    className="h-full w-auto object-contain"
  /> 
</div>

      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl text-gray-400">{blog.category}</h2>
        <h1 className="text-4xl font-bold pt-2 pb-5">{blog.title}</h1>
        <p className="text-gray-400 pt-2 pb-5">{blog.date} by {blog.author}</p>
        <img src={blog.image || Feat} alt="Blog Post" className="w-full h-auto object-cover mb-6 rounded-lg" />

        <div
          className="text-gray-300 max-w-none space-y-4 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />

        <div className="text-center mt-8">
          <Link to="/resources">
            <button className="bg-[#0B1E33] px-4 py-2 rounded-lg shadow-md text-white hover:bg-[#102a45] transition">
              Back to Blogs
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogPost;
